import { forEach } from 'ramda';

let middlewareEvents = {};


export const eventListener = (app, watchers)=> {

  if(middlewareEvents[app]) {
    forEach((e) => {
      window.document.removeEventListener(e.name, e.effect);
    }, middlewareEvents[app]);
  }
  

  return ({ dispatch, getState }) => {
    middlewareEvents[app] = [];
      forEach((watcher) => {
        const obj= {name:watcher.name, effect:(data)=> watcher.effect(data.detail, {dispatch, getState})};
        middlewareEvents[app].push(obj);
        window.document.addEventListener(obj.name, obj.effect);
      }, watchers);
      return (next) => (action) => {
        return next(action);
    };
  }
};

export default eventListener;